<template>
  <div class="am-addon-edit">
    <div class="am-addOn-title-bar am-main-top-box">
      <span class="am-addOn-title am-main-top-box-title"><strong>Edit Add-On</strong></span>
    </div>

    <div class="am-addOn-form">
      <div class="form-group">
        <label>Name:</label>
        <input type="text" class="form-control input-xs" v-model="addOn.name"/>
      </div>

      <div class="form-group">
        <label>Cost:</label>
        <input type="text" class="form-control input-xs" v-model="addOn.cost">
      </div>

      <div class="form-group">
        <label>Cost Type:</label>
        <select class="form-control input-xs" v-model="addOn.cost_type">
          <option value="1">Dollar</option>
          <option value="2">Percent</option>
        </select>
      </div>

      <div class="form-group">
        <label>Type:</label>
        <select class="form-control input-xs" v-model="addOn.bill_type">
          <option value="per_office">Per Office</option>
          <option value="per_employee">Per Employee</option>
          <option value="flat_monthly">Flat Monthly</option>
          <option value="per_broker">Per Broker</option>
          <option value="per_customer">Per Customer</option>
          <option value="per_active_customer">Per Customer (Active Only)</option>
          <option value="written_premium">Written Premium</option>
          <option value="per_customer_receipt">Per Customer Receipt</option>
        </select>
      </div>

      <div class="form-group">
        <label>Include Level:</label>
        <select class="form-control input-xs" v-model="addOn.lite_switch">
          <option value="1">Lite</option>
          <option value="0">Gold</option>
          <option value="2">Platinum</option>
          <option value="3">Diamond</option>
          <option value="4">Enterprise</option>
          <option value="100">Carrier</option>
          <option value="999">None</option>
        </select>
      </div>

      <div class="form-group">
        <label>Commissionable:</label>
        <select class="form-control input-xs" v-model="addOn.isCommissionable">
          <option value="1">Yes</option>
          <option value="0">No</option>
        </select>
      </div>

      <div class="form-row">
        <div class="form-group">
          <div class="am-addOn-blue-border"></div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <div class="am-addOn-align-bottom-buttons">
            <div class="am-addOn-float-right">
              <button type="button" class="btn btn-secondary"  @click="closeModal()">Cancel</button>
              <button type="button" class="btn btn-primary" @click="onSubmit">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from './../http'
export default {
  data: function () {
    return {
      name: 'AddOnEdit',
      addOn: {}
    }
  },

  methods: {
    closeModal () {
      this.$modal.hide('editAddOn')
    },

    onSubmit () {
      let self = this
      let data = this.addOn
      api.postRequest('backoffice/addOnsUpdate/' + this.addOn.id, data).then(
        (data) => {
          self.closeModal()
          location.reload()
        })
    }
  },

    mounted () {
        this.addOn = Object.assign({}, this.editAddOn)
    },

  props: {
    editAddOn: {
      type: Object,
      default: null
    }
  }
}
</script>

<style scoped>
  .am-addon-edit {
    width: 500px;
  }

  .am-addOn-form {
    padding: 15px;
  }

  .am-addOn-title-bar {
    height: 40px;
  }

  .am-addOn-title {
    font-size: 16px;
    color: #FDFEFE;
    float: left;
    margin: 10px 0px 0px 15px;
  }

  .am-addOn-blue-border {
    display: block;
    width: 100%;
    border-top: 1px solid #4297d7;
  }

  .am-addOn-float-right {
    margin-left: 320px;
  }

</style>
